import type { RowExport } from '@/components/ui/table/exportRows'
import type { HoldingRow } from '../types'

const COLUMNS = [
  { key: 'accountLabel', label: 'Account' },
  { key: 'periodLabel', label: 'Statement' },
  { key: 'symbol', label: 'Symbol' },
  { key: 'description', label: 'Description' },
  { key: 'subAccount', label: 'Sub-account' },
  { key: 'assetClass', label: 'Asset class' },
  { key: 'quantity', label: 'Quantity' },
  { key: 'price', label: 'Price' },
  { key: 'marketValue', label: 'Value' },
  { key: 'costBasis', label: 'Cost basis' },
  { key: 'statementFileName', label: 'Statement file' },
  { key: 'sourcePage', label: 'Page' },
]

// The holdings the search shows, with the file name the screen keeps in the tooltip.
export const holdingsExport = (holdings: HoldingRow[]): RowExport => ({
  columns: COLUMNS,
  rows: holdings as unknown as Record<string, unknown>[],
})
